import React, { useEffect } from "react";
import BrokerAdminNavigation from "../general/BrokerAdminNavigation";
import GeneralAuthentication from "../general/GeneralAuthentication";
import * as theme from "../theme";
import PerfectScrollbar from "react-perfect-scrollbar";
import WelcomeBackRightPane from "../general/WelcomeBackRightPane";
import BrokerageDetails from "../brokerageadmin/BrokerageDetails";
import InsurerContacts from "../brokerageadmin/InsurerContacts";
import UserManagement from "../brokerageadmin/UserManagement";
import LogoAndColor from "../brokerageadmin/BrokerageAdminLogoAndColor";
import AboutUsWrapper from "../brokerageadmin/BrokerageAdminAboutUs";
import CustomizeAPI from "../brokerageadmin/CustomizeAPI";
import UserData from "../brokerageadmin/UserData";
import PaymentDetails from "../brokerageadmin/PaymentDetails";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { getBrokerInformation, verifyToken } from "../store/broker";
import Payment from "./payment/Payment";
import TransactionList from "./transactions/TransactionList";
import GroupManagement from "../brokerageadmin/GroupManagement";
import BMSAdmin from "../brokerageadmin/BMSAdmin";
import translations from "../utils/translations";
import SSOManagement from "./SSOManagement";
import StytchOrgManagement from "./StytchOrgManagement";

function ActiveTab(props) {
  //let view = props.match.params.view;
  const { view } = useParams();
  if (view === "details") {
    return <BrokerageDetails />;
  } else if (view === "insuredcontacts") {
    return <InsurerContacts />;
  } else if (view === "bms") {
    return <BMSAdmin />;
  } else if (view === "branding") {
    return <LogoAndColor />;
  } else if (view === "apistatus") {
    return <CustomizeAPI />;
  } else if (view === "user") {
    return <UserManagement />;
  } else if (view === "paymentdetails") {
    return <PaymentDetails />;
  } else if (view === "userdata") {
    return <UserData />;
  } else if (view === "aboutus") {
    return <AboutUsWrapper />;
  } else if (view === "payment") {
    return <Payment />;
  } else if (view === "transaction") {
    return <TransactionList />;
  } else if (view === "groupmanagement") {
    return <GroupManagement />;
  }
  else if (view === "ssoDashboard") {
    return<>  <SSOManagement />
    <StytchOrgManagement/>  
    
    </>;
  } 
   else {
    return <WelcomeBackRightPane />;
  }
}

const BrokerAdmin = (props) => {
  const dispatch = useDispatch();
  const broker = useSelector(getBrokerInformation);
  const curTab = ActiveTab(props);
  const { view } = useParams();
  useEffect(() => {
    dispatch(verifyToken());
  }, [dispatch]);

  return (
    <div>
      {broker.istokenvalid & broker.isadmin ? (
        <div
          style={{
            heigth: "100%",
            width: "100%",
            overflow: "hidden",
            backgroundColor: theme.COLORS.tertiary_ligthindigo,
          }}
        >
          <GeneralAuthentication>
            <BrokerAdminPanel
              style={{ overflow: "hidden" }}
              leftPane={curTab ? curTab : <WelcomeBackRightPane />}
              rightPane={
                <BrokerAdminNavigation active={view} broker={broker} />
              }
              leftPaneWidth={"85%"}
              rightPaneWidth={"15%"}
            />
          </GeneralAuthentication>
        </div>
      ) : (
        <GeneralAuthentication>
          <h1>Error: Access Denied</h1>
        </GeneralAuthentication>
      )}
    </div>
  );
};

const BrokerAdminPanel = (props) => {
  let leftPanel = props.leftPane ? props.leftPane : <div></div>;
  let rightPane = props.rightPane ? props.rightPane : <div></div>;

  let leftPaneWidth = props.leftPaneWidth
    ? props.leftPaneWidth
    : theme.SCALES.quotesLeftPaneWidth;
  let rightPaneWidth = props.rightPaneWidth
    ? props.rightPaneWidth
    : theme.SCALES.quotesRightPaneWidth;

  return (
    <div style={{ display: "flex", height: "100%", width: "100%" }}>
      <div
        style={{
          width: leftPaneWidth,
          height: "100%",
          backgroundColor: theme.COLORS.tertiary_lightbackground,
          boxShadow: "20px 20px 30px 0px #AFB6CC",
          zIndex: 2,
        }}
      >
        <BrokerAdminLeftPane leftPane={leftPanel} />
      </div>
      <div
        style={{
          width: rightPaneWidth,
          height: "100%",
          zIndex: 1,
          backgroundColor: theme.COLORS.tertiary_ligthindigo,
        }}
      >
        {rightPane}
      </div>
    </div>
  );
};

const BrokerAdminLeftPane = (props) => {
  let leftPane = props.leftPane ? props.leftPane : <div></div>;
  const broker = useSelector(getBrokerInformation);
  const languagepreference = broker.information.languagepreference;

  const commonStyleForTableBox = {
    border: "5px solid white",
    borderRadius: 10,
    backgroundColor: theme.COLORS.help_tip,
    boxShadow: "0px 0 30px 0px #AFB6CC",
    paddingLeft: 20,
    paddingRight: 20,
  };

  return (
    <div style={{ width: "100%", height: "94vh" }}>
      <PerfectScrollbar>
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            paddingLeft: "15%",
            paddingRight: "15%",
          }}
        >
          {}
          <div
            style={{
              fontFamily: "GibsonSemiBd",
              fontSize: "1.5vw",
              color: theme.COLORS.primary_navyblue,
              display: "flex",
              paddingTop: "2%",
            }}
          >
            {translations[languagepreference].brokerageAdmin.topAdminHeader}
          </div>
          <br />
        </div>
        <div
          style={{
            marginLeft: "10%",
            marginRight: "10%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            ...commonStyleForTableBox,
          }}
        >
          {leftPane}
        </div>
      </PerfectScrollbar>
    </div>
  );
};

export default BrokerAdmin;
